export default __webpack_public_path__ + "static/media/strasbourg12.0d933e08.jpg";